export default "https://cdn-static.gokick.com/assets/24c3578bda803cdf114b208e53f44151315faa60/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";